export function metaReportCacheKey(from, to, platform = 'both') {
    return `${from}|${to}|${platform || 'both'}`;
}

export function googleReportCacheKey(from, to) {
    return `${from}|${to}`;
}

export function combinedReportCacheKey(from, to) {
    return `${from}|${to}`;
}

export function metaCityDailyCacheKey(from, to, platform, campaignIdsKey) {
    return `${from}|${to}|${platform || 'both'}|${campaignIdsKey || ''}`;
}

/**
 * Cache architecture (see marketingAdsReducer / marketingAdsSelectors):
 *
 * - One entry PER date-range (+ Meta platform), not one entry per channel.
 *   Going A -> B -> A therefore hits the cache for A instead of refetching.
 * - Entries are served instantly, then revalidated in the background once
 *   they are older than TTL (stale-while-revalidate). Historical ranges
 *   barely change, so they get a longer TTL; ranges that include today
 *   change intraday (new spend + lead-status movement), so they get a
 *   short one. This is what keeps the data "correct every time" without
 *   ever showing the full-page loader for a range you already have.
 * - The Both (combined) view has NO cache of its own: it reads/writes the
 *   Meta (`platform=both`) and Google entries for the same range. Syncing
 *   or refreshing either channel therefore updates Both automatically,
 *   and opening Both warms the Meta/Google tabs (and vice versa).
 */
export const MARKETING_ADS_TTL_TODAY_MS = 2 * 60 * 1000;
export const MARKETING_ADS_TTL_HISTORICAL_MS = 15 * 60 * 1000;
export const MARKETING_ADS_MAX_ENTRIES = 8;

function localToday() {
    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${now.getFullYear()}-${month}-${day}`;
}

export function isMarketingAdsEntryFresh(entry, to) {
    if (!entry?.lastUpdated) return false;
    const ttl = to && to >= localToday()
        ? MARKETING_ADS_TTL_TODAY_MS
        : MARKETING_ADS_TTL_HISTORICAL_MS;
    return Date.now() - entry.lastUpdated < ttl;
}
